// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"6e6fda44","112":"600ade4e","258":"a45b48f9","377":"e739fdc4","417":"cb8f86fe","467":"82b25deb","626":"d480170c","870":"df5923dc"}[chunkId] + ".js";
};